const Header = ({ isHub }) => (
  <div className="header">
    <div className="container">
      {isHub ? (
        <h2 className="mobile-heading">Clinical Hub</h2>
      ) : (
        <div className="logos">
          <img
            alt="healthline logo"
            className="hl"
            src="/images/healthline.png"
          />
          <img alt="st johns logo" className="sj" src="/images/st-johns.png" />
          <img
            alt="wellington free ambulance logo"
            className="wfa"
            src="/images/wellington-free.png"
          />
        </div>
      )}
    </div>
  </div>
);

export default Header;
